import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import DocumentVersion from '../../../interfaces/document-version';
import { BehaviorSubject, Subscription } from 'rxjs';
import ID from '../../../types/id';
import {
  CREATE_VERSION,
  CreateVersionInput,
  DELETE_VERSIONS,
  GET_VERSIONS,
  UPDATE_VERSION,
  UpdateVersionInput,
} from './graphql/document-versions';
import DocumentSubtypeDueDate from '../../../interfaces/document-subtype-due-date';

@Injectable({
  providedIn: 'root',
})
export class DocumentVersionsService {
  private _versions: DocumentVersion[] = [];
  private versions = new BehaviorSubject(this._versions);
  public versions$ = this.versions.asObservable();

  private _dueDates: DocumentSubtypeDueDate[] = [];
  private dueDates = new BehaviorSubject(this._dueDates);
  public dueDates$ = this.dueDates.asObservable();

  private _loading: boolean = false;
  private loading = new BehaviorSubject(this._loading);
  public loading$ = this.loading.asObservable();

  constructor(private apollo: Apollo) {}

  private setVersions(versions: DocumentVersion[]) {
    this._versions = versions;
    this.versions.next(this._versions);
  }

  private setLoading(loading: boolean) {
    this._loading = loading;
    this.loading.next(this._loading);
  }

  private setDueDates(dueDates: DocumentSubtypeDueDate[]) {
    this._dueDates = dueDates;
    this.dueDates.next(this._dueDates);
  }

  public getVersions(documentId: ID) {
    this.setLoading(true);
    this.apollo
      .query({
        query: GET_VERSIONS,
        variables: { document_id: documentId },
        fetchPolicy: 'network-only',
      })
      .subscribe(({ data }) => {
        if (data) {
          this.setVersions(data.versionsByDocId);
          if (data.documentSubtypeDueDates) {
            this.setDueDates(data.documentSubtypeDueDates);
          }
        }
        this.setLoading(false);
      });
  }

  public createVersion(input: CreateVersionInput) {
    return this.apollo.mutate({
      mutation: CREATE_VERSION,
      variables: { input },
    });
  }
  public updateVersions(id: ID, input: UpdateVersionInput) {
    return this.apollo.mutate({
      mutation: UPDATE_VERSION,
      variables: {
        id,
        input,
      },
    });
  }
  public deleteVersions(document_version_id: ID, type: string) {
    return this.apollo.mutate({
      mutation: DELETE_VERSIONS,
      variables: { document_version_id, type },
    });
  }
  public tearDown() {}
}
